module.exports = __webpack_public_path__ + "static/media/25_shape_l.203bd0ab.webp";